import React from "react";
import { StageIcons } from "../../../Utils/Constants";
import { components } from "react-select";

export default function SingleStageValue({ children, data, ...props }) {
  return (
    <components.SingleValue {...props}>
      <div className="stage-selected-value">
        {StageIcons[data.value] ? (
          <img src={StageIcons[data.value]} alt="type" />
        ) : (
          data.label
        )}
      </div>
    </components.SingleValue>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Brand/components/SingleStageValue.js